// export default process.env.NODE_ENV === 'production' ? 'https://sfantugheorghe.verdedata.ro' : 'http://localhost:10000'
export default process.env.NODE_ENV === 'production' ? 'https://consolidari-bucuresti.verdedata.ro' : 'http://localhost:10200'
